module.exports = {"TXTWCL_Resend_code":{"id":"TXTWCL_Resend_code","defaultMessage":"Νέα αποστολή κωδικού","track":"Resend code"}}